fx.ns("requests", class OldUploadRequest extends fx.Service
{
    constructor(data)
    {
        super();

        this.model = data;

        this._uploadFileProgressHandler = this._uploadFileProgress.bind(this);
    }

    get currentFile()
    {
        return this._currentFile;
    }

    uploadFile(url, file)
    {
        this.trigger("photo-upload-started", this);

        this._currentFile = file;
        
        this._currentFile._upload.uploading = true;
        this._currentFile._upload.uploaded = false;
        this._currentFile._upload.tries++;
                                      
        let timeout = 600000;
        var formData = new FormData();
        // fix problem when register after uploading pictures
        if(!("accountid" in this._currentFile.uploadParams))
            formData.append('accountid', this.model.account.id);

        for(let property in this._currentFile.uploadParams)
            if (property != "mediatype")
                formData.append( property, this._currentFile.uploadParams[property] );
            
        if (this._currentFile.social)
        {
            formData.append( "mediatype", "social" );
            formData.append( "socialmedia", this._currentFile.social );
            formData.append( "url", this._currentFile.media_url );
        }
        else
        {
            formData.append( "mediatype", this._currentFile.uploadParams["mediatype"] );
            formData.append('file', this._currentFile.file);
        }

        if (this._currentFile.filter)
        {
            //params.removeBackground = 1;
            formData.append( "filter",  this._currentFile.filter);
            formData.append( "imageWidth", this._currentFile.imageWidth);
            formData.append( "imageHeight", this._currentFile.imageHeight);

            timeout = 120000;
        }

        this.post(url, formData, this._uploadFile, {processData: false,  contentType: false, timeout : timeout, progressCallBack : this._uploadFileProgressHandler, maxTries : 1 });
    }

    _uploadFile(result)
    {
        if (!result.error && result.id)
        {
            this._currentFile._upload.loaded = this._currentFile._upload.size || fx.get("settings").socialFileSize;
            this._currentFile._upload.uploading = false;
            this._currentFile._upload.uploaded = true;
            
            Utils.temporaryId(this._currentFile.id, result.id);

            /*if (result.accountid != this.model.account.id)
                this.model.photos.reaffectPhotos( this.model.creation.id, this.model.account.id, result.accountid);*/
            
            if (this._currentFile instanceof fx.Model)
            {
                this._currentFile.prop("oldid", this._currentFile.id);

                this._currentFile.clean();

                if (this._currentFile instanceof models.ThemeLayout)
                    this._currentFile.update(result);
                else
                    this._currentFile.update({
                                    id : result.id,
                                    hash : this._currentFile.id,
                                    width : result.width,
                                    height : result.height,
                                    number : this._currentFile.number, // so we force update this value in case it was updated while photo was uploading
                                    deleted : this._currentFile.deleted, // -- same
                                    faces : this._currentFile.faces, // -- same
                                    average_color : this._currentFile.average_color,
                                    thumb : result.thumb ? Utils._fixURL(result.thumb) : this._currentFile.thumb,
                                    url : result.url ? Utils._fixURL(result.url) : this._currentFile.url,
                                    light_url : (result.light_url || result.url) ? Utils._fixURL(result.light_url || result.url) : this._currentFile.light_url,
                                    urls : result.urls || this._currentFile.urls,
                                    effects : result.effects || this._currentFile.effects,
                                });

                this._currentFile.event("media-file-uploaded");

                if (result.ai_success === false)
                    this._currentFile.event("ai-filter-failed");
            }
        

            this.trigger("photo-upload-finished", this);
        }
        else
        {
            //this._currentFile._upload.lastError = result;
            this._currentFile._upload.uploading = false;
            this._currentFile._upload.uploaded = false;
            this._currentFile._upload.loaded = 0;

            this.trigger("photo-upload-error", this);
        }        
    }

    _uploadFileProgress(loaded, total)
    {
        if (this._currentFile.file && this._currentFile.file.size )
           this._currentFile._upload.loaded = loaded;

        if (this._currentFile instanceof fx.Model)
            this._currentFile.event("upload-file-progress");

        this.trigger("photo-upload-progress", this);
    }

});